﻿window.cObjetStructuresContactMetier = function (objet) {
    var Me = this;
    this.data = objet.data;
    this.objet = objet;

    var idChampTableFonction = 53

    this.mGetTableUpdateLib = function () { return ["champ_table_nomprenom", "champ_table_nomstructure"] }

    var _lstChampTableData = null
    this.mGetLstChampTableData = function (funcOkAsync) {
        if (_lstChampTableData == null) {
            if (typeof objet.data == 'undefined' || objet.id == null) {
                //on est sur un element non sauvegardé
                _lstChampTableData = []
                if (typeof funcOkAsync != 'undefined') funcOkAsync(_lstChampTableData)
            } else {
                Me.objet.bddRef.mAjaxCall({
                    command: "getchamptabledata",
                    id_table: objet.mGetTable().id_table,
                    id: objet.id,
                    id_historique_sup: objet.id_historique_sup,
                    async: (typeof funcOkAsync != 'undefined')
                }, function (data) {
                    _lstChampTableData = ((typeof data.lstdata == 'undefined') ? [] : data.lstdata)
                    if (typeof funcOkAsync != 'undefined') funcOkAsync(_lstChampTableData)
                })
            }
        } else {
            if (typeof funcOkAsync != 'undefined') funcOkAsync(_lstChampTableData)
        }
        return _lstChampTableData
    }
    this.mSetLstChampTableData = function (lstChampTableData) {
        _lstChampTableData = lstChampTableData
    }
    this.mSetLstChampTableData = function (lstChampTableData) {
        _lstChampTableData = lstChampTableData
    }
    this.mGetLibBase = function () { return "Structures/contact"; }
    this.mGetAttributBase = function () { return "le " }
    this.mGetNewLib = function () { return "Nouveau contact"; }
    this.mGetLib1 = function (option) {
        if (typeof option == 'undefined') option = {}
        if (typeof option.dataTemplate != 'undefined') {
            return mGetLib1(option.dataTemplate)
        } else {
            if (typeof objet.data == 'undefined') {
                if (typeof option != 'undefined' && typeof option.callBack != 'undefined') { option.callBack("") }
                else { return "" }
            } else {
                var txt = ""
                if (Me.objet.cle() == null) {
                    if (typeof option != 'undefined' && typeof option.callBack != 'undefined') { option.callBack(txt) }
                    else { return txt }
                } else {
                    Me.objet.bddRef.mAjaxCall({
                        command: "getlstdatavirtualgrid",
                        data: [{ id_table: Me.objet.mGetTable().id_table, id: Me.objet.cle() }],
                        async: (typeof option.callBack != 'undefined')
                    }, function (data) {
                        var dataTemplate = ((typeof data.lstdatatemplate == "undefined") ? null : data.lstdatatemplate[0])
                        txt = ((dataTemplate == null) ? "" : mGetLib1(dataTemplate))
                    })
                    return txt
                }
            }
        }

        function mGetLib1(dataTemplate) {
            var txt = ""
            if ((dataTemplate.con_nom == null || dataTemplate.con_nom.length == 0) && (dataTemplate.con_prenom == null || dataTemplate.con_prenom.length == 0)) { txt = "" }
            else {
                var txt = "";
                if (dataTemplate.con_nom != null && dataTemplate.con_nom.length > 0) txt += dataTemplate.con_nom;
                if (dataTemplate.con_prenom != null && dataTemplate.con_prenom.length > 0) {
                    if (txt.length > 0) txt += " ";
                    txt += dataTemplate.con_prenom;
                }
            }
            if (dataTemplate.nom_str == null) { txt = "/" + txt }
            { txt = dataTemplate.nom_str + "/" + txt }
            if (typeof option != 'undefined' && typeof option.callBack != 'undefined') { option.callBack(txt) }
            else { return txt }
        }
        //var str = Me.objet.bddRef.getObjet("structures", objet.data.id_structures)
        //var con = Me.objet.bddRef.getObjet("contact", objet.data.id_contact)
        //return str.mGetLib1() + "/" + con.mGetLib1()
    }
    this.mGetLib2 = function () {
        return ""
    }

    this.mGetNomFromTemplate = function (dataTemplate) {
        return this.mGetLibNomPrenomFromDataTemplate(dataTemplate)
    }
    this.mGetLibNomPrenomFromDataTemplate = function (dataTemplate) {
        var txt = ""
        var objStr = Me.objet.bddRef.getObjet("structures")
        var objCon = Me.objet.bddRef.getObjet("contact")
        var nomStr = objStr.objetMetier.mGetLibNomPrenomFromDataTemplate(dataTemplate)
        var nomCon = objCon.objetMetier.mGetLibNomPrenomFromDataTemplate(dataTemplate)
        return nomStr + "/" + nomCon
    }

    this.mGetNom = function () {
        return this.mGetLib1()
        //var str = Me.objet.bddRef.getObjet("structures", objet.data.id_structures)
        //var con = Me.objet.bddRef.getObjet("contact", objet.data.id_contact)
        //var txt = str.mGetLib1()
        //if (con.mGetLib1().length > 0) txt += ((txt.length > 0) ? "/" : "") + con.mGetLib1()
        //return txt
    }

    this.mGetRadiusImage = function () { return "0" }
    this.mGetResume = function () {
        var txt = "";
        if (typeof objet.data == 'undefined') {
            //on est sur une nouvelle structures contact
            return String.fromCharCode(8230) + "/" + String.fromCharCode(8230)
        } else {
            txt = this.mGetLib1()
            //var str = Me.objet.bddRef.getObjet("structures", objet.data.id_structures)
            //var con = Me.objet.bddRef.getObjet("contact", objet.data.id_contact)
            //var strResume = str.mGetResume()
            //var conResume = con.mGetResume()
            //strResume = ((strResume.length > 0) ? strResume : String.fromCharCode(8230))
            //conResume = ((conResume.length > 0) ? conResume : String.fromCharCode(8230))
            //return str.mGetResume() + "/" + con.mGetResume()
        }
        return txt;
    }

    this.mGetIcone = function (dataTemplate) {
        var $Icone = $("<i class='fas fa-portrait' style='position:relative' title='Structure/contact'><i class='fas fa-home' style='position:absolute;bottom:-2px;right:-4px;opacity:1;font-size:65%;color:" + theme.backgroundcolorAccent + "'></i></i>");
        if (typeof objet.data != 'undefined') {
            if (typeof objet.data.id_compte_client != 'undefined' && objet.data.id_compte_client != null) {
                $("<i class='fas fa-burst' style='position:absolute;top:-5px;right:-5px;color:red;font-size:65%;'></i>").appendTo($Icone)
            }
        } else if (typeof dataTemplate != 'undefined') {
            if (typeof dataTemplate.id_compte_client != 'undefined' && dataTemplate.id_compte_client != null) {
                $("<i class='fas fa-burst' style='position:absolute;top:-5px;right:-5px;color:red;font-size:65%;'></i>").appendTo($Icone)
            }
        }
        return $Icone
    }
    this.mGetImageData = function (opt) {
        opt.bddCtrl = Me.objet.bddRef
        opt.data = this.mGetDataContact()
        opt.data2 = this.mGetDataStructures()
        return $("<div/>").dxCtrlImageData(opt).dxCtrlImageData("instance")
    }

    this.mGetLstChampTable = function () {
        return Me.objet.bddRef.mGetArray("champ_table")
        //return Me.objet.bddRef.mGetArray("champ_table").filter(function (o) {
        //    switch (parseInt(o.id_champ_table)) {
        //        case parametre.champ.id_champ_table_dossier:
        //        case parametre.champ.id_champ_table_email:
        //        case parametre.champ.id_champ_table_fonction:
        //        case parametre.champ.id_champ_table_interet:
        //        case parametre.champ.id_champ_table_mobile:
        //        case parametre.champ.id_champ_table_siteweb:
        //        case parametre.champ.id_champ_table_tel:
        //        case parametre.champ.id_champ_table_nomprenom:
        //            return true;
        //        default:
        //            return false;
        //    }
        //})

        ////var lstChampOrder = []
        ////Me.objet.bddRef.mGetArray("champ_table_config").filter(function (o) {
        ////    return o.id_table == objet.mGetTable().id_table;
        ////}).sort(function (o1, o2) { return parseInt(o1.tri) - parseInt(o2.tri) }).forEach(function (champTableConfig) {
        ////    var champTable = Me.objet.bddRef.mGetArray("champ_table").filter(function (o) { return o.id_champ_table == champTableConfig.id_champ_table })[0]
        ////    if (champTable.id_champ_table != parametre.champ.id_champ_table_nomstructure && champTable.id_champ_table != parametre.champ.id_champ_table_nomprenom) lstChampOrder.push(champTable)
        ////})
        ////return lstChampOrder
        //////return Me.objet.bddRef.mGetArray("champ_table").filter(function (o) { return o.id_table == objet.mGetTable().id_table; }).sort(function (o1, o2) { return parseInt(o1.tri) - parseInt(o2.tri) })
    }

    this.contentTemplateGrid = function (contentElement, option) {
        contentElement.empty();
    }
    this.mGetDataItemTemplate = function (funcOk) {
        this.mGetLstChampTableData(function (lstChampTableData) {
            var chData = new cTableChampData(Me.objet.bddRef, lstChampTableData)
            var adr = chData.mGetAdressePostaleDefaut()
            if (adr) {
                var obj = Me.objet.bddRef.getObjet(adr)
                adr = obj.objetMetier.mGetLibelleCourt()
            } else { adr = "" }
            var tel = ((objet.data.tel_sms == null) ? "" : objet.data.tel_sms)
            if (tel) {
                var obj = Me.objet.bddRef.getObjet(tel)
                tel = obj.objetMetier.mGetValueMiseEnForme()
            } else { tel = "" }
            var mobile = chData.mGetMobileDefaut()
            if (mobile) {
                var obj = Me.objet.bddRef.getObjet(mobile)
                mobile = obj.objetMetier.mGetValueMiseEnForme()
            } else { mobile = "" }
            var email = chData.mGetAdresseEmailDefaut()
            if (email) { email = email.valeur }
            else { email = "" }
            var site = chData.mGetSiteDefaut()
            if (site) { site = site.valeur }
            else { site = "" }
            funcOk({
                adr: adr,
                tel: tel,
                mobile: mobile,
                email: email,
                site: site
            })
        })
    }

    this.hasScrollPopup = function () { return false }
    //this.contentTemplatePopup = function (contentElement, option) {
    //    $("<div/>").appendTo(contentElement).dxCtrlPopupFicheContactEtActivite({
    //        bddCtrl: Me.objet.bddRef,
    //        id_table_destinataire: objet.mGetTable().id_table,
    //        id_destinataire: objet.cle(),
    //        onSelectionChanged: option.onSelectionChanged
    //    })
    //}

    //this.contentTemplateSaisie = function (contentElement, option) {
    //    contentElement.empty();
    //    if (typeof option == 'undefined') option = {}
    //    var objMaitre = null
    //    if (option.fromParentContact) {
    //        objMaitre = Me.objet.bddRef.getObjet("structures", objet.data.id_structures)
    //    } else {
    //        objMaitre = Me.objet.bddRef.getObjet("contact", objet.data.id_contact)
    //    }
    //    var lst = objMaitre.objetMetier.contentTemplateSaisie(contentElement, {
    //        showOnlyNom: true,
    //        hideOrganiserFiche: true
    //    })
    //    var dxCtrlChampTable = $("<div style='padding:10px;'/>").appendTo(contentElement).dxCtrlChampTableData({
    //        bddCtrl: Me.objet.bddRef,
    //        id_table: objet.mGetTable().id_table,
    //        id: objet.data.id_structures_contact,
    //        data: objet.data,
    //        objet: objet,
    //        onChange: option.onChange,
    //        onContentReady: option.onContentReady
    //    }).dxCtrlChampTableData("instance")
    //    lst.push(dxCtrlChampTable)
    //    var nbValue = objMaitre.objetMetier.mNbValue(false)
    //    var $Div = $("<div style='padding:0 0 5px 5px;'/>").appendTo(contentElement)
    //    if (option.fromParentContact) {
    //        var $A1 = $("<a href='javascript:void(0)' style='font-size:90%;'>Afficher les données détaillés de la structure" + ((nbValue > 0) ? " (" + nbValue + " valeur" + ((nbValue > 1) ? "s" : "") + ")" : "") + "</a>").appendTo($Div)
    //        $A1.attr("title", "Afficher l'ensemble des données de la structure")
    //        //var tt1 = $("<div/>").appendTo("body").dxCtrlTooltipHoverTarget({
    //        //    target: $A1, position: "top", contentTemplate: function (contentElement) {
    //        //        $("<div style='font-size:110%;'>Afficher l'ensemble des données de la structure</div>").appendTo(contentElement);
    //        //    }
    //        //}).dxCtrlTooltipHoverTarget("instance");
    //    } else {
    //        var $A1 = $("<a href='javascript:void(0)' style='font-size:90%;'>Afficher les données personnelles du contact" + ((nbValue > 0) ? " (" + nbValue + " valeur" + ((nbValue > 1) ? "s" : "") + ")" : "") + "</a>").appendTo($Div)
    //        $A1.attr("title", "Afficher l'ensemble des données lié personnellement au contact")
    //        //var tt1 = $("<div/>").appendTo("body").dxCtrlTooltipHoverTarget({
    //        //    target: $A1, position: "top", contentTemplate: function (contentElement) {
    //        //        $("<div style='font-size:110%;'>Afficher l'ensemble des données lié personnellement au contact</div>").appendTo(contentElement);
    //        //    }
    //        //}).dxCtrlTooltipHoverTarget("instance");
    //    }
    //    var $DivDataPerso = null
    //    $A1.on("click", function () {
    //        if ($DivDataPerso == null) {
    //            $DivDataPerso = $("<div style='display:none;'/>").appendTo(contentElement)
    //            var $Table = $("<table style='width:100%'/>").appendTo($DivDataPerso)
    //            var $Tr = $("<tr/>").appendTo($Table)
    //            var $Td = $("<td style='width:50px;transform:rotate(180deg);writing-mode:tb-rl;padding-bottom:10px;vertical-align:top;text-align:right;font-size:140%;line-height:1;border-left:" + theme.border + ";'>Données<br/>personnelles</td>").appendTo($Tr)
    //            var $Td = $("<td style=''/>").appendTo($Tr)
    //            objMaitre.objetMetier.contentTemplateSaisie($Td, {
    //                hideNom: true,
    //                hideDossier: true
    //            })
    //        }
    //        if ($DivDataPerso.is(":visible")) { $DivDataPerso.slideUp() } else {
    //            $DivDataPerso.slideDown(200, function () {
    //                window.setTimeout(function () {
    //                    if (typeof option.dxScroll != "undefined") option.dxScroll.scrollTo(option.dxScroll.scrollTop() +150)
    //                }, 100)
    //            })
    //        }
    //    })
    //    return lst
    //}

    this.mGetDataContact = function () {
        return Me.objet.bddRef.getObjet("contact", objet.data.id_contact).data
    }
    this.mGetDataStructures = function () {
        return Me.objet.bddRef.getObjet("structures", objet.data.id_structures).data
    }

    this.mGetWidthPopup = function () { return 750 }
    this.isPopupFullScreen = true
    //this.mShowPopup = function (option) {
    //    if (typeof option == 'undefined') option = {}
    //    if (typeof option.fullScreen == 'undefined') option.fullScreen = true
    //    page.mAddPopup(objet.data, option)
    //}
    this.contentTemplatePopup = function (contentElement, option) {
        $("<div/>").appendTo(contentElement).dxCtrlPopupFicheContactEtActivite({
            bddCtrl: Me.objet.bddRef,
            id_table_destinataire: objet.mGetTable().id_table,
            id_destinataire: objet.cle(),
            onSelectionChanged: option.onSelectionChanged,
            optionPopup: option,
            getUrl: function (funcOk) {
                objet.mGetDataTemplate([], function (dataTemplate) {
                    if (dataTemplate.site_web != null && dataTemplate.site_web.length > 0) { funcOk(dataTemplate.site_web) }
                    else { funcOk(objet.mGetLib1()) }
                })
            }
        })
    }

    this.mAddEventChangeLib = function (container, func) {
        Me.objet.bddRef.mAddFunctionOnModifiedItemData(["champ_table_nomprenom"], container,
            function (action, itemData) {
                if (typeof itemData != 'undefined' && itemData.id_table == Me.objet.bddRef.table.mGetIdTable("contact")) {
                    if (itemData.id_champ_table == parametre.champ.id_champ_table_nomprenom && itemData.id == objet.data.id_contact) {
                        func()
                    }
                }
            })
        Me.objet.bddRef.mAddFunctionOnModifiedItemData(["champ_table_string"], container,
            function (action, itemData) {
                if (typeof itemData != 'undefined' && itemData.id_table == Me.objet.bddRef.table.mGetIdTable("structures")) {
                    if (itemData.id_champ_table == Me.objet.bddRef.getObjet("structures").objetMetier.idChampTableNom && itemData.id == objet.data.id_structures) {
                        func()
                    }
                }
            })
    }

    //return le champValeur unitaire à partir d'un champTable
    this.mGetChampTableDataUnitaire = function (chpTableData) {
        var champTableData = new cTableChampData(Me.objet.bddRef, this.mGetLstChampTableData())
        return champTableData.mGetChampTableData(chpTableData)
    }
    //return la liste des champValeur à partir d'un champTable
    this.mGetLstChampTableDataUnitaire = function (chpTableData) {
        var champTableData = new cTableChampData(Me.objet.bddRef, this.mGetLstChampTableData())
        return champTableData.mGetLstChampTableData(chpTableData)
    }

    //return l'adresse postale au niveau du strcon
    this.mGetChampAdressePostaleDefautDirect = function () {
        var champTableData = new cTableChampData(Me.objet.bddRef, this.mGetLstChampTableData())
        var dataAdr = champTableData.mGetAdressePostaleDefaut()
        if (typeof dataAdr != 'undefined' && dataAdr != null) { return dataAdr }
        else { return null }
    }

    this.mGetChampAdressePostaleDefaut = function () {
        var dataAdr = this.mGetChampAdressePostaleDefautDirect()
        if (typeof dataAdr != 'undefined' && dataAdr != null) { return dataAdr }
        else { return Me.objet.bddRef.getObjet(this.mGetDataStructures()).objetMetier.mGetChampAdressePostaleDefaut() }
    }

    //return l'adresse email au niveau du strcon
    this.mGetChampAdresseEmailDefautDirect = function () {
        var champTableData = new cTableChampData(Me.objet.bddRef, this.mGetLstChampTableData())
        var dataAdrMail = champTableData.mGetAdresseEmailDefaut()
        if (typeof dataAdrMail != 'undefined' && dataAdrMail != null) { return dataAdrMail }
        else { return null }
    }

    this.mGetChampAdresseEmailDefaut = function () {
        var dataAdrMail = this.mGetChampAdresseEmailDefautDirect()
        if (typeof dataAdrMail != 'undefined' && dataAdrMail != null) { return dataAdrMail }
        else { return Me.objet.bddRef.getObjet(this.mGetDataStructures()).objetMetier.mGetChampAdresseEmailDefaut() }
    }

    this.mGetAdresseEmailDefaut = function () {
        var champTableData = this.mGetChampAdresseEmailDefaut()
        if (champTableData != null) { return champTableData.valeur }
        else { return "" }
    }

    this.mGetChampSiteDefaut = function () {
        return null
    }

    this.mAddAdresseEmailSiVide = function (adrEmail) {
        if (this.mGetAdresseEmailDefaut().length == 0) {
            //on a pas de mail
            var champTableEmail = Me.objet.bddRef.mGetArray("champ_table").filter(function (o) { return o.id_table == objet.mGetTable().id_table; }).filter(function (o) { return o.id_champ_table == parametre.champ.id_champ_table_email })[0]
            var typeChamp = new cTypeChamp(champTableEmail.id_type_champ, Me.objet.bddRef)
            champDataEmail = typeChamp.mGetNewData(champTableEmail, objet.mGetTable().id_table, objet.cle())
            champDataEmail.valeur = adrEmail

            var tableChampDataEmail = new cTableChampData(Me.objet.bddRef)
            tableChampDataEmail.mSaveChampTableData("id_champ_table_email", champDataEmail, objet,
                function (obj) { obj.mSave() },
                null)
        }
    }

    //return le tel au niveau du strcon
    this.mGetChampTelDefautDirect = function () {
        var champTableData = new cTableChampData(Me.objet.bddRef, this.mGetLstChampTableData())
        var dataTelephone = champTableData.mGetTelephoneDefaut()
        if (typeof dataTelephone != 'undefined' && dataTelephone != null) { return dataTelephone }
        else { return null }
    }

    this.mGetChampTelDefaut = function () {
        var dataTelephone = this.mGetChampTelDefautDirect()
        if (typeof dataTelephone != 'undefined' && dataTelephone != null) { return dataTelephone }
        else { return Me.objet.bddRef.getObjet(this.mGetDataStructures()).objetMetier.mGetChampTelDefaut() }
    }

    this.mGetTelephoneDefaut = function () {
        var dataTelephone = this.mGetChampTelDefaut()
        if (typeof dataTelephone != 'undefined' && dataTelephone != null) { return Me.objet.bddRef.getObjet(dataTelephone).objetMetier.mGetValueMiseEnForme() }
        else { return "" }
    }

    //return le tel au niveau du strcon
    this.mGetChampMobileDefautDirect = function () {
        var champTableData = new cTableChampData(Me.objet.bddRef, this.mGetLstChampTableData())
        var dataTelephone = champTableData.mGetMobileDefaut()
        if (typeof dataTelephone != 'undefined' && dataTelephone != null) { return dataTelephone }
        else { return null }
    }

    this.mGetChampMobileDefaut = function () {
        var dataTelephone = this.mGetChampMobileDefautDirect()
        if (typeof dataTelephone != 'undefined' && dataTelephone != null) { return dataTelephone }
        else { return Me.objet.bddRef.getObjet(this.mGetDataStructures()).objetMetier.mGetChampMobileDefaut() }
    }

    this.mGetMobileDefaut = function () {
        var dataTelephone = this.mGetChampMobileDefaut()
        if (typeof dataTelephone != 'undefined' && dataTelephone != null) { return Me.objet.bddRef.getObjet(dataTelephone).objetMetier.mGetValueMiseEnForme() }
        else { return "" }
    }

    this.mAddTelMobileSiVide = function (dataTel) {
        if (this.mGetMobileDefaut().length == 0 && dataTel != null && dataTel.tel_number.length > 0) {
            //on a pas de mobile
            var champTableMobile = Me.objet.bddRef.mGetArray("champ_table").filter(function (o) { return o.id_table == objet.mGetTable().id_table; }).filter(function (o) { return o.id_champ_table == parametre.champ.id_champ_table_mobile })[0]
            var typeChamp = new cTypeChamp(champTableMobile.id_type_champ, Me.objet.bddRef)
            champDataMobile = typeChamp.mGetNewData(champTableMobile, objet.mGetTable().id_table, objet.cle())

            champDataMobile.tel_code_pays = dataTel.tel_code_pays
            champDataMobile.tel_number = dataTel.tel_number
            champDataMobile.tel_complet = dataTel.tel_complet
            champDataMobile.telb_sms = dataTel.tel_sms
            champDataMobile.tel_error = dataTel.tel_error
            champDataMobile.tel_num_type = dataTel.tel_num_type

            var tableChampData = new cTableChampData(Me.objet.bddRef)
            tableChampData.mSaveChampTableData("id_champ_table_mobile", champDataMobile, objet,
                function (obj) { obj.mSave() },
                null)
        }
    }

    this.mCreateStructuresContact = function (dataStructure, dataContact, value, funcOk) {

        var dataStructureContact = Me.objet.bddRef.getObjet("structures_contact").mGetNewData()
        dataStructureContact.id_structures = dataStructure.id_structures
        dataStructureContact.id_contact = dataContact.id_contact

        var lstChampTableData = []
        var lstChampTable = Me.objet.bddRef.mGetArray("champ_table")//.filter(function (chp) {
        //    return Me.objet.bddRef.mGetArray("champ_table_config").filter(function (chpConf) {
        //        return chp.id_champ_table == chpConf.id_champ_table && chpConf.id_table == objet.mGetTable().id_table;
        //    }).length > 0
        //})

        if (typeof value.adresse_email != 'undefined' && value.adresse_email != null) {
            //adresse email
            var champTable = lstChampTable.filter(function (chTab) { return chTab.id_champ_table == parametre.champ.id_champ_table_email })[0]
            var typeChamp = new cTypeChamp(champTable.id_type_champ, Me.objet.bddRef)
            champTableData = typeChamp.mGetNewData(champTable, objet.mGetTable().id_table, null)
            champTableData.nom_table_champ_table = "champ_table_email"
            champTableData.valeur = value.adresse_email
            lstChampTableData.push(champTableData)
        }
        if (typeof value.tel_fixe != 'undefined' && value.tel_fixe != null) {
            //téléphone fixe
            var champTable = lstChampTable.filter(function (chTab) { return chTab.id_champ_table == parametre.champ.id_champ_table_tel })[0]
            var typeChamp = new cTypeChamp(champTable.id_type_champ, Me.objet.bddRef)
            champTableData = typeChamp.mGetNewData(champTable, objet.mGetTable().id_table, null)
            champTableData.nom_table_champ_table = "champ_table_tel"
            champTableData.valeur = value.tel_fixe.valeur
            champTableData.code_pays = value.tel_fixe.code_pays
            lstChampTableData.push(champTableData)
        }
        if (typeof value.tel_mobile != 'undefined' && value.tel_mobile != null) {
            //téléphone mobile
            var champTable = lstChampTable.filter(function (chTab) { return chTab.id_champ_table == parametre.champ.id_champ_table_mobile })[0]
            var typeChamp = new cTypeChamp(champTable.id_type_champ, Me.objet.bddRef)
            champTableData = typeChamp.mGetNewData(champTable, objet.mGetTable().id_table, null)
            champTableData.nom_table_champ_table = "champ_table_tel"
            champTableData.valeur = value.tel_mobile.valeur
            champTableData.code_pays = value.tel_mobile.code_pays
            lstChampTableData.push(champTableData)
        }
        dataStructureContact.id_utilisateur = Me.objet.bddRef.utiCourant.id_utilisateur

        Me.objet.bddRef.mAjaxCall({ command: "create_structure_contact_with_data", data: dataStructureContact, lst_champ_table_data: lstChampTableData }, function (data) {
            dataStructureContact.id_structures_contact = data.id
            funcOk(dataStructureContact)
        })
    }

    this.mGetPopupPositionWidthHeight = function () {
        return Me.objet.bddRef.getObjet("structures").mGetPopupPositionWidthHeight()
        //return {
        //    width: "500",
        //    maxWidth: "calc(100% - 60px)",
        //    height: "calc(100% - 90px)",
        //    maxHeight: "calc(100% - 50px)",
        //    position: {
        //        my: "right top",
        //        at: "right top",
        //        of: "body",
        //        offset: { x: -30, y: 65 }
        //    }
        //}
    }


    this.mGetDisplayInPopup = function (newValue) {
        if (typeof objet.bddRef.utiCourantParaJson["dataDisplayInPopup_structures"] == 'undefined') {
            objet.bddRef.utiCourantParaJson["dataDisplayInPopup_structures"] = true
        }
        if (typeof newValue != 'undefined') {
            objet.bddRef.utiCourantParaJson["dataDisplayInPopup_structures"] = newValue
            objet.bddRef.mSaveParaJsonUtilisateur();
        }
        return objet.bddRef.utiCourantParaJson["dataDisplayInPopup_structures"]
    }

    this.mPrint = function () {
        jaugeDemarrage.mShow()
        objet.bddRef.mAjaxCall({
            command: "printstrcon",
            id_table: objet.mGetTable().id_table,
            id: objet.cle()
        }, function (data) {
            if (data.urlpdf) {
                if (data.urlpdf.startsWith("~")) data.urlpdf = data.urlpdf.substring(1)
                $("<div/>").dxCtrlPdfViewer({
                    urlPdf: data.urlpdf,
                    allowClose: true,
                    padding: "0px"
                })
                jaugeDemarrage.mHide()
            }
        })
    }

    this.mGetLstDataStrCon = function (idStructures, idContact, funcEnd) {
        var lst = []
        var result = objet.bddRef.mAjaxCall({
            command: "getlstdatastrcon",
            id_structures: idStructures,
            id_contact: idContact,
            async: (funcEnd ? true : false)
        }, function (data) {
            if (!data.lstdatastructurescontact) data.lstdatastructurescontact = []
            lst = data.lstdatastructurescontact
            if (funcEnd) funcEnd(lst)
        })
        return lst
    }

}